import axiosBase from "axios";
import axios from "./axiosInstance";
import {
  WORKFLOW_SIGNED_URL,
  WORKFLOW_EXTRACT,
  WORKFLOW_VEHICLE_ALL,
} from "./apiEndPoints";
import {
  IExtractedData,
  IWorkflowSignedUrl,
  IWorkflowUploadResult,
} from "../components/types/workflow.types";

export const MAX_WORKFLOW_IMAGE_BYTES = 10 * 1024 * 1024; // 10 MB
export const ACCEPTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
];

const EXTRACT_TIMEOUT_MS = 60000;

export function validateImageFile(file: File): string | null {
  if (!ACCEPTED_IMAGE_TYPES.includes(file.type)) {
    return "Please choose a JPG, PNG, or WEBP image.";
  }
  if (file.size > MAX_WORKFLOW_IMAGE_BYTES) {
    return "Please choose an image smaller than 10 MB.";
  }
  return null;
}

export async function getWorkflowUploadUrl(
  fileName: string,
  contentType: string
): Promise<IWorkflowSignedUrl> {
  const res = await axios.get(WORKFLOW_SIGNED_URL, {
    params: { fileName, contentType },
  });
  const signed = res.data as IWorkflowSignedUrl;
  if (!signed?.signedUrl || !signed?.key || !signed?.fileUrl) {
    throw new Error("Could not start the upload. Please try again.");
  }
  return signed;
}

export async function uploadImageToWorkflow(
  file: File,
  docType: string,
  vehicleNumber = ""
): Promise<IWorkflowUploadResult> {
  const signed = await getWorkflowUploadUrl(file.name, file.type);

  await axiosBase.put(signed.signedUrl, file, {
    headers: { "Content-Type": file.type },
  });

  const res = await axios.post(
    WORKFLOW_EXTRACT,
    { fileUrl: signed.fileUrl, docType, vehicleNumber },
    { timeout: EXTRACT_TIMEOUT_MS }
  );

  return {
    key: signed.key,
    fileUrl: signed.fileUrl,
    extractedData: (res.data ?? {}) as IExtractedData,
  };
}

export async function fetchWorkflowVehicleNumbers(): Promise<string[]> {
  const res = await axios.get(WORKFLOW_VEHICLE_ALL);
  const results = res.data?.results;
  return Array.isArray(results) ? results : [];
}
